import React, { useRef } from 'react';

const Card = (props) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    card.style.transform = `perspective(600px) rotateY(${x * 6}deg) rotateX(${y * -6}deg)`;
  };

  const handleMouseLeave = () => {
    if (cardRef.current) {
      cardRef.current.style.transform = 'perspective(600px) rotateY(0deg) rotateX(0deg)';
    }
  };

  return (
    <div 
      className={`timeline__item ${props.type}`}
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ animationDelay: `${props.index * 0.15}s` }}
    >
      <div className='timeline__item-connector'>
        <div className='timeline__item-dot'>
          <i className={props.icon}></i>
        </div>
        <div className='timeline__item-line'></div>
      </div>

      <div className='timeline__item-content'>
        <div className='timeline__item-header'>
          <span className='timeline__item-year'>{props.year}</span>
          <div className='timeline__item-badge'>
            <span>{props.type === 'education' ? '📚' : '💼'}</span>
          </div>
        </div>

        <h3 className='timeline__item-title'>{props.title}</h3>
        <p className='timeline__item-desc'>{props.desc}</p>

        <div className='timeline__item-hover-effect'>
          <span className='hover-arrow'>→</span>
        </div>
      </div>
    </div>
  );
};

export default Card;